// Simple in-memory cache for GitHub API responses
const cache = {
  data: {},
  timestamps: {},
  TTL: 5 * 60 * 1000, // 5 minutes cache
};

export const fetchWithCache = async (url) => {
  const now = Date.now();
  
  // Check if we have cached data that's still valid
  if (cache.data[url] && cache.timestamps[url] && (now - cache.timestamps[url] < cache.TTL)) {
    return cache.data[url];
  }

  // Check if there's already a pending request for this URL
  if (cache.data[url + '_pending']) {
    // Wait for the pending request
    return cache.data[url + '_pending'];
  }

  // Create a new request promise and store it
  const fetchPromise = fetch(url)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      cache.data[url] = data;
      cache.timestamps[url] = Date.now();
      delete cache.data[url + '_pending'];
      return data;
    })
    .catch(error => {
      delete cache.data[url + '_pending'];
      throw error;
    });

  cache.data[url + '_pending'] = fetchPromise;
  return fetchPromise;
};
